import React, { Children, ReactNode } from 'react';
import router from './router';
import withBaseUrl from './utils/withBaseUrl';

interface ILinkProps {
  href: string;
  onClick?: Function;
  children: string | ReactNode;
}

function isClickForNewWindow(e) {
  // https://github.com/zeit/next.js/blob/canary/lib/link.js#L44-L48
  return (
    e.currentTarget.nodeName === 'A' &&
    (e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      (e.nativeEvent && e.nativeEvent.which === 2))
  );
}

function onLinkClick(e, { href, onClick }) {
  if (typeof onClick === 'function') {
    onClick(e);
  }

  if (e.defaultPrevented || isClickForNewWindow(e)) {
    return;
  }

  e.preventDefault();

  router.pushState(href);
}

function Link({ href, onClick, children }: ILinkProps) {
  if (!React.isValidElement(children)) {
    children = <a>{children}</a>;
  }

  return React.cloneElement(Children.only<any>(children), {
    href: withBaseUrl(href, router.baseUrl),
    target: router.target,
    onClick: (e) => onLinkClick(e, { href, onClick }),
  });
}

export default Link;
